import styled from 'styled-components';

export const InterestLevelsContainer = styled.div`
  margin-top: 16px;
`;
